<div class="col-md-12">
  <div class="row" style="padding-top: 15px">
    <div class="col-md-12 mt-2 mb-3 header-title-search">
      <h4 class="flex-align-items space-between mb-0">
        <span>{{ 'AccountUsers' | translate }} <app-help hrefKey="ExternalHelp.organizations" /></span>
        <button type="button" (click)="showModalAddUser()" class="btn btn-sm btn-primary btn-sm">
          <i class="icofont icofont-ui-add"></i>
          <span>{{ 'AddUser' | translate }}</span>
        </button>
      </h4>
      <div class="searchs">
        <div class="form-group search-line">
          <label>{{ 'Search' | translateLabel }}</label>
          <input
            [formControl]="filters"
            class="form-control form-control-sm search-bar"
            id="search"
            placeholder="{{ 'OrganizationUserSearchPlaceholder' | translate }}"
            type="text"
          />
        </div>
        <div class="form-group search-line">
          <label>{{ 'Role' | translateLabel }}</label>
          <select
            [formControl]="roleFilter"
            class="form-control form-control-sm select-role text-ellipsis"
            style="max-width: 250px"
          >
            <option [ngValue]="null">{{ 'All' | translate }}</option>
            <option *ngFor="let r of ROLES" [ngValue]="r">
              {{ ROLES_MAP[r] | translate }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <ngx-datatable
    [messages]="{ emptyMessage: translate.instant('NoData') }"
    class="data-table table-responsive mb-3"
    [limit]="20"
    [rows]="users"
    [columnMode]="ColumnMode.force"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="40"
  >
    <ngx-datatable-column [flexGrow]="1">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'NomPrénom(s)' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span title="{{ fullName(row.user) }}">{{ fullName(row.user) ?? '-' }}</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="1">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Email' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span title="{{ row.user.email }}">{{ row.user.email }}</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="1">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Statut' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template
        ><i>{{ row.user.isActive ? ('Actif' | translate) : ('InvitationPending' | translate) }}</i></ng-template
      >
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="2" [resizeable]="false">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'role' | translate }}
        <app-help tooltipKey="OrganizationRoleTooltip" tooltipPlacement="bottom" />
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <select
          [ngModel]="row.role"
          [disabled]="row.user.email == auth.user.email || row.role == OWNER"
          (change)="showModalUpdate(row.role, row.user.email, $event)"
          class="select-role text-ellipsis"
        >
          <option *ngFor="let r of ROLES" [hidden]="r == OWNER" [value]="r">
            {{ ROLES_MAP[r] | translate }}
          </option>
        </select>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [minWidth]="80" [maxWidth]="80" [resizeable]="false" cellClass="actions">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Actions' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <i
          *ngIf="row.user.email != auth.user.email && row.role != OWNER"
          title="{{ 'supprimer' | translate }}"
          [attr.name]="row.user.email + '-delete'"
          (click)="showModalDelete(row.user.email)"
          class="icofont icofont-ui-delete"
        ></i>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template let-curPage="index" let-pageSize="size">
        <small class="ogo-ngx-datatable-footer"
          >Total : {{ nbUsers }}
          {{ nbUsers > 1 ? ('users' | translate) : ('user' | translate) }}
        </small>
        <datatable-pager
          [pagerLeftArrowIcon]="pager.PREV"
          [pagerRightArrowIcon]="pager.NEXT"
          [pagerPreviousIcon]="pager.FIRST"
          [pagerNextIcon]="pager.LAST"
          [page]="page + 1"
          [size]="size"
          [count]="nbUsers"
          (change)="changePage($event)"
        >
        </datatable-pager>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
</div>

<app-modal-basic #modalAddUser [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <small [innerHTML]="'AddUser' | translate"></small>
    </h4>
    <button type="button" class="close basic-close" (click)="modalAddUser.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group ng-select-no-dropdown">
          <label>Email(s)</label>
          <ng-select
            #addUserInput
            (paste)="onPasteEmails($event)"
            (add)="onAddItem($event)"
            class="select-site-selector"
            [multiple]="true"
            [addTag]="true"
            [(ngModel)]="newUsers"
            [clearable]="false"
            [searchable]="true"
            [openOnEnter]="false"
            [closeOnSelect]="true"
            [placeholder]="'EnterEmail' | translate"
            [inputAttrs]="{ 'data-form-type': 'other' }"
            (blur)="handleAddUserBlur()"
            (search)="handleAddUserType($event)"
          ></ng-select>
        </div>
        <div style="margin-top: -10px; margin-bottom: 10px; font-size: 12px; color: #969696">
          <i>{{ 'PressEnterToAdd' | translate }}{{ 'SeparatedEmails' | translate }}</i>
        </div>
        <div class="form-group">
          <app-label label="role" tooltip="OrganizationRoleTooltip" />
          <select [(ngModel)]="newUsersRole" class="form-control">
            <option *ngFor="let r of ROLES" [value]="r" [hidden]="r == OWNER">
              {{ ROLES_MAP[r] | translate }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button
      (click)="addUser()"
      class="btn btn-primary btn-sm"
      [disabled]="!newUsers.length"
      [innerHTML]="'Ajouter' | translate"
    ></button>
    &nbsp;
    <button
      (click)="modalAddUser.hide()"
      class="btn btn-danger btn-sm pull-right"
      [innerHTML]="'Fermer' | translate"
    ></button>
  </div>
</app-modal-basic>
